/**
 * @generated SignedSource<<e5bd1b896c4c49b674a2f3cfc0d28d44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Notifications$data = {
  readonly notifications: {
    readonly unseenNotificationCount: number;
  } | null;
  readonly " $fragmentType": "Notifications";
};
export type Notifications$key = {
  readonly " $data"?: Notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"Notifications">;
};

import NotificationsRefetchQuery_graphql from './NotificationsRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "collabContextRoutingAri"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": NotificationsRefetchQuery_graphql
    }
  },
  "name": "Notifications",
  "selections": [
    {
      "concreteType": "InfluentsNotificationQuery",
      "kind": "LinkedField",
      "name": "notifications",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "collabContextRoutingAri",
              "variableName": "collabContextRoutingAri"
            }
          ],
          "kind": "ScalarField",
          "name": "unseenNotificationCount"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "31af0dc011e585e154d3c49db2198487";

export default node;
